import { serviceMaker, methods, api } from "./index.js";

export const createChargeCode = (data) =>
  serviceMaker(`/chargecode`, methods.POST, api.NGB, data);

export const updateChargeCode = (id, data) =>
  serviceMaker(`/chargecode/${id}`, methods.PUT, api.NGB, data);

export const chargeCodeTemplate = () =>
  serviceMaker(`/chargecode/template`, methods.GET, api.NGB);

export const getChargeCode = (id) =>
  serviceMaker(`/chargecode/${id}`, methods.GET, api.NGB);

export const chageCodeList = () =>
  serviceMaker(`/chargecode`, methods.GET, api.NGB);

export const chageCodeListDelete = (id) =>
  serviceMaker(`/chargecode/${id}`, methods.DELETE, api.NGB);
